import { apiAxios } from "../../apiConfig";

// Upload Photos API (multi-file)
export const uploadPhotos = async (formData) => {
  try {
    const response = await apiAxios.post("/gallery", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error uploading photos:", error);
    throw error?.response?.data || error;
  }
};

// Get Gallery Counts API
export const getGalleryCounts = async () => {
  try {
    const response = await apiAxios.get("/gallery/counts");
    return response.data;
  } catch (error) {
    console.error("Error fetching gallery counts:", error);
    throw error?.response?.data || error;
  }
};

export const getAllGalleryPhotos = async () => {
  try {
    const response = await apiAxios.get("/gallery");
    return response.data;
  } catch (error) {
    console.error("Error fetching gallery photos:", error);
    throw error?.response?.data || error;
  }
};

// Delete Gallery Photo API
export const deleteGalleryPhoto = async (photoId) => {
  try {
    const response = await apiAxios.delete(`/gallery/${photoId}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting gallery photo:", error);
    throw error?.response?.data || error;
  }
};

// ── Gallery Category APIs ──

export const getGalleryCategories = async () => {
  try {
    const response = await apiAxios.get("/gallery-categories");
    return response.data;
  } catch (error) {
    console.error("Error fetching gallery categories:", error);
    throw error?.response?.data || error;
  }
};

export const createGalleryCategory = async (name) => {
  try {
    const response = await apiAxios.post("/gallery-categories", { name });
    return response.data;
  } catch (error) {
    console.error("Error creating gallery category:", error);
    throw error?.response?.data || error;
  }
};

export const updateGalleryCategory = async (id, name) => {
  try {
    const response = await apiAxios.put(`/gallery-categories/${id}`, { name });
    return response.data;
  } catch (error) {
    console.error("Error updating gallery category:", error);
    throw error?.response?.data || error;
  }
};

export const deleteGalleryCategory = async (id) => {
  try {
    const response = await apiAxios.delete(`/gallery-categories/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting gallery category:", error);
    throw error?.response?.data || error;
  }
};
